// src/services/supabaseRange.js
export function isRange416(err) {
  return err?.status === 416 || /(^|[^0-9])416([^0-9]|$)/.test(String(err?.message || ''));
}

export async function safeRangeQuery(q, from, to) {
  try {
    const { data, error } = await q.range(from, to);
    if (error) {
      if (isRange416(error)) return { data: [], error: null }; // liste vide -> pas une erreur
      throw error;
    }
    return { data, error: null };
  } catch (e) {
    if (isRange416(e)) return { data: [], error: null };
    throw e;
  }
}
